import React from "react";
import navbar from "../../assets/images/logo/blueNav.png";
import { useSidebar } from "../../utils/helpers/SidebarContext";
import NavDropDown from "./NavDropDown";
import { SwrinkArrowIcon, WideArrowIcon } from "assets/icons";
import { CustomTooltip } from "components";
import { useNavigate } from "react-router-dom";

const MainNavBar: React.FC<any> = () => {
  const { isOpen, toggleSidebar } = useSidebar();
   const navigate = useNavigate();
  return (
    <div className="flex flex-row h-14 bg-white border border-primary-50">
      <div className="flex w-1/5 justify-start items-center">
        <div className="flex justify-center items-center">
          <CustomTooltip
            title={isOpen ? "Collapse sidebar" : "Expand sidebar"}
            placement={"left"}
            arrow
          >
            <button
              className="h-10 w-10 rounded-full hover:bg-primary-100 flex justify-center items-center transition-all duration-300"
              onClick={toggleSidebar}
            >
              {isOpen ? (
                <SwrinkArrowIcon className="size-4 text-primary-900 hover:text-primary-500" />
              ) : (
                <WideArrowIcon className="size-4 text-primary-900 hover:text-primary-500" />
              )}{" "}
            </button>
          </CustomTooltip>
        </div>
      </div>
      <div onClick={()=>navigate("/main-dashboard")} className="flex w-3/5 content-center justify-center">
        <img
          className="w-60 object-scale-down"
          src={navbar}
          alt="Educareskill"
        />
      </div>
      <NavDropDown />
    </div>
  );
};

export default MainNavBar;
